import React, { Component } from 'react';
import { Link } from "react-router-dom";

import EmployeeService from '../Services/EmployeeService';



class UpdateEmployee extends Component {

    constructor(props) {
        super(props);
        const url = window.location.href;

        console.log(url);

        let [x, k] = url.split('=');
        console.log(k);
        this.state = {

            emp_id: +k,
            first_name: '',
            last_name: '',
            email: '',
            mobile: '',
            dob: '',
            gender: '',
            address: '',
            country: '',
            city: ''

        }

        this.changeFirstNameHandler = this.changeFirstNameHandler.bind(this);
        this.changeLastNameHandler = this.changeLastNameHandler.bind(this);
        this.changeAddressHandler = this.changeAddressHandler.bind(this);
        this.changeEmailHandler = this.changeEmailHandler.bind(this);
        this.changeMobileHandler = this.changeMobileHandler.bind(this);
        this.changeGenderHandler = this.changeGenderHandler.bind(this);
        this.changeCountryHandler = this.changeCountryHandler.bind(this);
        this.updateEmployee = this.updateEmployee.bind(this);
        this.changeDobHandler = this.changeDobHandler.bind(this);
        this.changeSkillHandler = this.changeSkillHandler.bind(this);
        this.changeCityHandler = this.changeCityHandler.bind(this);

        this.back = this.back.bind(this);
    }
    componentDidMount() {
        const url = window.location.href;

        // console.log(url);

        let [x, k] = url.split('=');

        EmployeeService.viewEmployee(k).then((res) => {

            this.setState(res.data);
        })

    }
    updateEmployee = (event) => {
        event.preventDefault();
        let emp = {
            emp_id: this.state.emp_id,
            first_name: this.state.first_name,
            address: this.state.address,
            last_name: this.state.last_name,
            email: this.state.email,
            mobile: this.state.mobile,
            dob: this.state.dob,
            gender: this.state.gender,
            country: this.state.country,
            city: this.state.city,
            skills: this.state.skills
        }
        console.log(emp);
        // let emp1 = JSON.stringify(stu);
        EmployeeService.updateEmployee(emp).then(res => {
            console.log(res);
            this.back();

        })

    }

    back() {
        console.log("back")
        window.location.href = "/employees";
    }
    changeFirstNameHandler = (event) => {
        this.setState({ first_name: event.target.value });
    }
    changeAddressHandler = (event) => {
        this.setState({ address: event.target.value });
    }
    changeLastNameHandler = (event) => {
        this.setState({ last_name: event.target.value });
    }
    changeEmailHandler = (event) => {
        this.setState({ email: event.target.value });
    }
    changeMobileHandler = (event) => {
        this.setState({ mobile: event.target.value });
    }

    changeGenderHandler = (event) => {
        this.setState({ gender: event.target.value });
    }
    changeCountryHandler = (event) => {
        this.setState({ country: event.target.value });
    }
    changeCityHandler = (event) => {
        this.setState({ city: event.target.value });
    }
    changeDobHandler = (event) => {
        this.setState({ dob: event.target.value });
    }
    changeSkillHandler = (event) => {
        this.setState({ skills: event.target.value.split(" ") });
    }

    render() {
        return (
            <div style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center' }}>
                <h1>Employee Update Form</h1>
                <div class="col-md-4 col-md-offset-3 col-md-offset-3" style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center', margin: 'auto' }} >
                    <section id="inner-wrapper" class="card-body">
                        <article style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center' }}>
                            <form style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center' }}>

                                <div class="form-group">
                                    First Name
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-user"> </i></span>
                                        <input type="text" class="form-control" placeholder="First Name" value={this.state.first_name} onChange={this.changeFirstNameHandler} label="First Name" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Last Name
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Last Name" value={this.state.last_name} onChange={this.changeLastNameHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Address
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Address" value={this.state.address} onChange={this.changeAddressHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Email
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Email" value={this.state.email} onChange={this.changeEmailHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Mobile
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Mobile" value={this.state.mobile} onChange={this.changeMobileHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Date Of Birth
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="date" class="form-control" placeholder="DOB " value={this.state.dob} onChange={this.changeDobHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Gender
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Gender" value={this.state.gender} onChange={this.changeGenderHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Country
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Country" value={this.state.country} onChange={this.changeCountryHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    City
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="City" value={this.state.city} onChange={this.changeCityHandler} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    Skills
                                    <div class="input-group">
                                        <span class="input-group-addon"><i class="fa fa-envelope"> </i></span>
                                        <input type="text" class="form-control" placeholder="Skills" value={this.state.skills} onChange={this.changeSkillHandler} />
                                    </div>
                                </div>
                                <Link to={'/employees'}>
                                    <button type="submit" class="btn btn-success btn-block" onClick={this.updateEmployee}>Submit</button>
                                </Link>
                                <Link to={'/employees'}>
                                    <button type="submit" class="btn btn-danger btn-block">Cancel</button>
                                </Link>
                            </form>
                        </article>
                    </section></div>
            </div>
        );
    }
}

export default UpdateEmployee;